<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Đăng ký phòng họp
      </h5>
    </template>

    <!--    <template #header>-->
    <!--      <div-->
    <!--        class="flex-row flex__center font-size__large font-weight__bold margin-top-10"-->
    <!--      >ĐĂNG KÝ PHÒNG HỌP</div>-->
    <!--    </template>-->

    <template #body>
      <!--      <div class="form-info">-->
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tiêu đề" prop="meetingTitle">
              <el-input
                v-model="form.meetingTitle"
                placeholder="Tiêu đề"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="100"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Nội dung cuộc họp" prop="meetingContent">
              <el-input
                type="textarea"
                v-model="form.meetingContent"
                placeholder="Nội dung cuộc họp"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="2000"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Thời gian bắt đầu" prop="startTime">
              <el-date-picker
                v-model="form.startTime"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
                @change="startTimeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Thời gian kết thúc" prop="endTime">
              <el-date-picker
                v-model="form.endTime"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Thành phần tham dự" prop="involedUserIds">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.involedUserIds"
                placeholder="Gõ để bắt đầu tìm kiếm theo email/họ tên/chức danh"
                size="medium"
                filterable
                clearable
                remote
                multiple
                :remote-method="remoteSearchInvoledUsers"
                :loading="isRemoteSearchInvoledUsers"
              >
                <el-option
                  v-for="item in involedUsers"
                  :key="item.id"
                  :label="getActorLabel(item)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            :span="24"
            v-if="isNewFlow"
          >
            <el-form-item label="Họp với đối tác ngoài" prop="withForeignPartnerChecked">
              <el-checkbox
                v-model="form.withForeignPartnerChecked"
                @change="changeWithForeignPartnerChecked"
              />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Thành phần khác" prop="otherInvolved">
              <el-input
                type="textarea"
                v-model="form.otherInvolved"
                placeholder="Thành phần khác"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="2000"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Độ quan trọng" prop="criticalLevel">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.criticalLevel"
                placeholder="Độ quan trọng"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in criticalLevels"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Dịch vụ chuẩn bị" prop="services">
              <el-checkbox-group v-model="form.services" class="width__100">
                <el-checkbox
                  v-for="item in serviceOptions"
                  :key="item.value"
                  :label="item.value"
                >{{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col
            :span="24"
            v-if="isNewFlow"
          >
            <el-form-item label="Số lượng họp" prop="peopleNum">
              <el-input-number
                size="small"
                v-model="form.peopleNum"
                :min="0"
              />
            </el-form-item>
          </el-col>

          <el-col
            :span="24"
            v-if="isNewFlow"
          >
            <el-form-item label="Lãnh đạo duyệt YC" prop="selectedApproverId">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.selectedApproverId"
                placeholder="Lựa chọn lãnh đạo duyệt yêu cầu"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in approvers"
                  :key="item.userId"
                  :label="getActorLabel(item)"
                  :value="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <!--      </div>-->
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
          :disabled="isSubmitting"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Gửi yêu cầu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import constants from "../../../constants";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import hanhchinhService from "../../../services/hanhchinhService";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import hcFlowService from "../../../services/hcFlowService";
  import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
  import utils from "../../../services/utils";
  import CustomDialog from "../../common/custom-dialog";
  import moment from "moment";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";

  export default {
    name: "hc-phonghop-create-dialog",
    props: ["isOpen", "id", "flowId", "deptId", "flowCode", "isNewFlow"],
    mixins: [handleRequestErrorMixin],
    components: {
      CustomDialog
    },

    data() {
      return {
        criticalLevels: null,
        serviceOptions: null,
        approvers: null,
        form: {
          meetingTitle: null,
          meetingContent: null,
          startTime: null,
          endTime: null,
          otherInvolved: null,
          criticalLevel: null,
          services: [],
          involedUserIds: null,
          withForeignPartnerChecked: false, // checkbox hop voi doi tac nuoc ngoai
          peopleNum: 0, // so luong nguoi hop
          selectedApproverId: null // user id cua lanh dao approve
        },
        rules: {
          meetingTitle: null,
          meetingContent: null,
          startTime: null,
          endTime: null,
          otherInvolved: null,
          criticalLevel: null,
          services: [],
          involedUserIds: null,
          selectedApproverId: null,
        },
        constraints: {
          defaultRequiredConstrains: {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          }
        },
        involedUsers: [],
        isRemoteSearchInvoledUsers: false,
        hcFlow: null,
        isSubmitting: false
      };
    },

    async created() {
      this.initSelectOptions();
      this.initValidationRules();
      this.initForm();
      await this.loadHcFlow();
    },

    methods: {
      loadHcFlow() {
        return hcFlowService
          .findById(this.flowId)
          .then(response => (this.hcFlow = response.data));
      },

      remoteSearchInvoledUsers(query) {
        this.isRemoteSearchInvoledUsers = true;
        (query
            ? userDeptRoleViewService
              .findAllForHcPhongHopOtherInvoled(query, this.hcFlow.deptId, {
                page: 0,
                size: 100,
                sort: "fullName,asc"
              })
              .then(
                response =>
                  (this.involedUsers = (response.data || []).sort(
                    (item1, item2) => utils.compareUserDeptRoleView(item1, item2)
                  ))
              )
            : Promise.resolve()
        ).then(() => (this.isRemoteSearchInvoledUsers = false));
      },

      getActorLabel(userDeptRoleView) {
        return utils.buildUserDeptRoleViewLabel(userDeptRoleView);
      },

      startTimeChanged() {
        this.initEndTime();
      },

      initForm() {
        this.form.criticalLevel =
          constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.KHONG_LANH_DAO;
        this.form.startTime = new Date();
        this.initEndTime();
      },

      initEndTime() {
        this.form.endTime = this.form.startTime
          ? new moment(this.form.startTime).add(1, "hour").toDate()
          : null;
      },

      initValidationRules() {
        this.rules.meetingTitle = [this.constraints.defaultRequiredConstrains];
        this.rules.meetingContent = [this.constraints.defaultRequiredConstrains];
        this.rules.startTime = [this.constraints.defaultRequiredConstrains];
        this.rules.endTime = [this.constraints.defaultRequiredConstrains];
        this.rules.selectedApproverId = [this.constraints.defaultRequiredConstrains];
      },

      initSelectOptions() {
        this.criticalLevels = hanhChinhUtils.buildPhongHopCriticalLevelOptions();
        this.serviceOptions = hanhChinhUtils.buildPhongHopServiceOptions();

        // Tao selection Lanh dao duyet YC
        userDeptRoleViewService.findAllActiveUsersInDeptWithRole(this.deptId, constants.ROLE.CODE.LANH_DAO)
          .then(res => {
            this.approvers = res.data
          })
          .catch(err => {
            console.log('Khong load duoc danh sach lanh dao');
            console.log(err)
          })
      },

      customLabelPriority(option) {
        return option.name;
      },

      convertToSubmitForm() {
        return {
          flowCode: this.flowCode,
          flowId: this.flowId,
          meetingTitle: this.form.meetingTitle,
          meetingContent: this.form.meetingContent,
          startTime: this.form.startTime ? this.form.startTime.getTime() : null,
          endTime: this.form.endTime ? this.form.endTime.getTime() : null,
          otherInvolved: this.form.otherInvolved,
          criticalLevel: this.form.criticalLevel,
          services: this.form.services,
          involedUserIds: this.form.involedUserIds,
          withForeignPartnerChecked: this.form.withForeignPartnerChecked, // hop voi doi tac nuoc ngoai
          peopleNum: this.form.peopleNum, // so nguoi tham gia
          selectedApproverId: this.form.selectedApproverId // lanh dao approve
        };
      },

      // Kiểm tra xem form có valid không, nếu không thì show error message
      validateForm() {
        return utils.validateFormCommon(this.$refs.form, this.$message);
      },

      // Kiểm tra tính hợp lệ của thời gian bắt đầu và thời gian kết thúc
      validateDateRange() {
        return new Promise(resolve => {
          let endTime = this.form.endTime;
          let startTime = this.form.startTime;
          if (endTime && startTime && endTime.getTime() < startTime.getTime()) {
            this.$message.error(
              errorMessageFilter({errorCode: "hcPhongHop.invalidTimeRange"})
            );
            return;
          }
          resolve();
        });
      },

      changeWithForeignPartnerChecked(newVal) {
        if(newVal === true)
          this.rules.otherInvolved = [this.constraints.defaultRequiredConstrains];
        else {
          this.rules.otherInvolved = null;
          this.$refs.form.clearValidate('otherInvolved')
        }
      },

      submit() {
        console.log('Gui yeu cau dang ky phong hop...');
        this.validateForm()
        .then(() => this.validateDateRange())
        .then(() => {
          this.isSubmitting = true;
          let submitForm = this.convertToSubmitForm();
          console.log('submitForm:', submitForm);
          return hanhchinhService
            .RegisterMeetingRoom(submitForm)
            .then(() => {
              this.$message.success(
                errorMessageFilter({
                  errorCode: "hcPhongHop.insertSuccess"
                })
              );
              this.$emit("success");
              this.isSubmitting = false;
            })
            .catch(error => {
              this.commonHandleRequestError(error);
              this.isSubmitting = false;
              throw error;
            });
        });
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/phonghop/PhongHop_Form.vue